module.exports = __webpack_public_path__ + "img/bet_amount_icon.a7348695.svg";